/*
 * «Токен ещё свежий?» — решает, нужен ли проактивный refresh перед запросом.
 *
 * Раньше считали только от tokenTime + REACT_APP_REFRESH_TIME, а там стоит 1
 * (минута). В итоге веб гонял /auth/refreshToken почти каждую минуту, и каждый
 * раз менял одноразовый refresh-токен. Любая перезагрузка/закрытие вкладки
 * посреди такого запроса, вторая вкладка или второе устройство — и на руках
 * остаётся уже использованный токен → 403 → разлогин.
 *
 * Теперь, если accessToken — JWT с exp, верим exp (обновляем за минуту до
 * истечения), как RN: он обновляет по факту, а не по таймеру. Если exp
 * прочитать нельзя — берём expiresIn из ответа refresh (RN: isSessionValid),
 * и только если нет и его — старое поведение по REACT_APP_REFRESH_TIME.
 * Страховка в любом случае есть: на 401 axios-interceptor сам обновит сессию.
 */
const EARLY_MS = 60 * 1000;

export function jwtExpMs(token?: string | null): number | null {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = JSON.parse(atob(b64 + "===".slice((b64.length + 3) % 4)));
    return typeof json.exp === "number" ? json.exp * 1000 : null;
  } catch (e) {
    return null;
  }
}

export function tokenTimeChecker(time: string, accessToken: string | null = window.localStorage.accessToken) {
  const exp = jwtExpMs(accessToken);
  if (exp !== null) return exp - Date.now() > EARLY_MS;

  // RN делает new Date(session.expiresIn) — это дата-строка или ms
  const rawExp = String(window.localStorage.tokenExpiresIn || "");
  const expiresIn = /^\d+$/.test(rawExp) ? Number(rawExp) : Date.parse(rawExp);
  if (!isNaN(expiresIn)) return expiresIn - Date.now() > EARLY_MS;

  if (!time) return false;
  const timeStamp = Date.parse(time) + 60 * 1000 * Number(process.env.REACT_APP_REFRESH_TIME);
  return timeStamp - Date.now() >= 6 * 1000;
}
